(function () {
  var knownCartCount = null;

  function fetchCart() {
    return window.fetch(window.Shopify.routes.root + 'cart.js').then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to read cart state');
      }

      return response.json();
    });
  }

  function refreshKnownCart() {
    return fetchCart().then(function (cart) {
      knownCartCount = cart.item_count;
      return cart;
    });
  }

  function waitForCartIncrease(baseline, itemCount, attempt) {
    return fetchCart().then(function (cart) {
      if (cart.item_count >= baseline + itemCount) {
        knownCartCount = cart.item_count;
        return cart;
      }

      if (attempt >= 40) {
        throw new Error('Renude cart update was not observed');
      }

      return new Promise(function (resolve) {
        window.setTimeout(resolve, 100);
      }).then(function () {
        return waitForCartIncrease(baseline, itemCount, attempt + 1);
      });
    });
  }

  function openCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }

  function notifyThemeCartUpdate(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'renude-analysis',
          data: {
            source: 'renude-analysis',
            itemCount: cart.item_count,
            sections: {},
          },
        },
      })
    );
  }

  var initialCartState = refreshKnownCart().catch(function () {
    knownCartCount = null;
  });

  document.addEventListener('cart:update', function (event) {
    if (event.detail && event.detail.sourceId === 'renude-analysis') {
      return;
    }

    refreshKnownCart().catch(function () {});
  });

  window.addEventListener(
    'message',
    function (event) {
      var iframe = document.getElementById('renude-analysis');
      if (!iframe || event.source !== iframe.contentWindow || !Array.isArray(event.data)) {
        return;
      }

      if (event.data[0] !== 'addToCart') {
        return;
      }

      var payload;
      try {
        payload = typeof event.data[1] === 'string' ? JSON.parse(event.data[1]) : event.data[1];
      } catch (error) {
        return;
      }

      if (!payload || !Array.isArray(payload.items) || !payload.items.length) {
        return;
      }

      var itemCount = payload.items.reduce(function (total, item) {
        return total + (Number(item.quantity) || 1);
      }, 0);

      initialCartState
        .then(function () {
          if (knownCartCount === null) {
            throw new Error('Cart baseline is unavailable');
          }

          return waitForCartIncrease(knownCartCount, itemCount, 0);
        })
        .then(function (cart) {
          notifyThemeCartUpdate(cart);
          openCartDrawer();
        })
        .catch(function () {});
    },
    false
  );
})();
